<template>
  <nav class="space-y-1">
    <GroupSelectorItem
      v-for="(option, index) in options"
      :key="index"
      :label="option.label"
      :is-current="value === index"
      :meta="metaByCategory[index]"
      @click="$emit('input', index)"
    />
  </nav>
</template>

<script>
import GroupSelectorItem from './group-selector-item.vue';

export default {
  components: {
    GroupSelectorItem,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    metaByCategory: {
      type: Object,
      required: true,
    },
  },
};
</script>
